import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';
export const getCategoriesFunc = createAsyncThunk(
    "getAllCategories",
    async (query = '', thunkAPI) => {
        try {
            const res = await api.get(`dashboard/categories${query}`);
            return res.data.data.categories;
        }
        catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }

    }
)

const getCategoriesSlicer = createSlice({
    name: "getAllCategories",
    initialState: {
        loading: false,
        data: [],
        error: null,
        apiErrors: {},
        successMessage: "",
    },
    reducer: {},
    extraReducers: (builder) => {
        builder.addCase(getCategoriesFunc.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.apiErrors = {};
        })
            .addCase(getCategoriesFunc.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.successMessage = action.payload?.message || "";

            })
            .addCase(getCategoriesFunc.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.apiErrors = action.payload?.errors || {};
            });
    }
})

export default getCategoriesSlicer.reducer;